import { render, staticRenderFns } from "./SafeBox.vue?vue&type=template&id=04e7d40a&scoped=true&"
import script from "./SafeBox.vue?vue&type=script&lang=js&"
export * from "./SafeBox.vue?vue&type=script&lang=js&"
import style0 from "./SafeBox.vue?vue&type=style&index=0&id=04e7d40a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7d40a",
  null
  
)

export default component.exports